import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";
import type { ZodSchemaOf } from "@@/shared/zod-helpers";
import { z } from "zod";
import type { PayRequestId} from "../pay-request-id";
import { payRequestIdZodSchema } from "../pay-request-id";
import type {
    PayRequestReferences} from "./_pay-request-references";
import {
    payRequestReferencesZodObject,
} from "./_pay-request-references";
import type {
    PayRequestEventId} from "./_pay-request.event-id";
import {
    payRequestEventIdZodSchema,
} from "./_pay-request.event-id";

const payRequestEventSchemaFactory = <
    const EventType extends Uppercase<`PAY_REQUEST_${string}_EVENT`>,
    PayRequestEventData,
>(
    type: EventType,
    dataSchema: z.ZodType<PayRequestEventData & { type: EventType }>,
) => {
    const schema = z.object({
        _id: payRequestEventIdZodSchema,
        _type: z.literal("PAY_REQUEST_EVENT"),
        _createdAt: isoAndUnixZodSchema,
        _happenedAt: isoAndUnixZodSchema,
        _version: z.number(),
        payRequestId: payRequestIdZodSchema,
        type: z.literal(type),
        /**
         * References, what is the pay request created for?
         * what order? order events? provider? e.t.c.
         */
        paymentFor: payRequestReferencesZodObject,
        data: dataSchema, //.and(z.object({ type: z.literal(type) })),
    });
    return schema as ZodSchemaOf<{
        // workaround for https://github.com/colinhacks/zod/issues/2260
        _id: PayRequestEventId;
        _type: "PAY_REQUEST_EVENT";
        _createdAt: IsoAndUnixTimestamp;
        _happenedAt: IsoAndUnixTimestamp;
        _version: number;
        payRequestId: PayRequestId;
        type: EventType;
        /**
         * References, what is the pay request created for?
         * what order? order events? provider? e.t.c.
         */
        paymentFor: PayRequestReferences;
        data: z.infer<typeof dataSchema>;
    }>;
};

export { payRequestEventSchemaFactory };
